import React, { FC } from 'react';
import { BoxProps, CONTENT_PADDING, CONTENT_WIDTH, Typography } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';

import { useMediaQuery } from '../../../hooks/useMediaQuery';
import { useUser } from '../../../hooks/useUser';
import { AppRoute, camelCasify, hasPermission, MainScreenTab } from '../../../utils/navigation';

import { DropDownMenu } from './dropDownMenu';
import { DropDownMenuItem } from './dropDownMenuItem';
import { MenuButton, StyledNavLink, TabMenu } from './styledComponents';

export interface TitleProps {
  tab: MainScreenTab;
}

export const TabMenuButton: FC<TitleProps> = ({ tab }) => {
  const { t } = useTranslation();
  const { user } = useUser();

  const buttonText = t(`mainScreen.tab.${camelCasify(tab)}`, {
    context: user?.type
  });

  return (
    <StyledNavLink to={tab} aria-label={buttonText}>
      {({ isActive }) => (
        <MenuButton isActive={isActive}>
          <Typography className="button-text">{buttonText}</Typography>
        </MenuButton>
      )}
    </StyledNavLink>
  );
};

// TODO: Remove component when the new design is fully implemented and the old design is removed
export const EFCMenu: FC<BoxProps> = () => {
  const { xsScreen } = useMediaQuery();
  const { user } = useUser();
  const isExpertUser = hasPermission(AppRoute.EXPERT_REGISTRATION, user);

  // Dropdown menu for small screens
  if (xsScreen) {
    return (
      <DropDownMenu>
        <DropDownMenuItem tab={MainScreenTab.BUILDINGS} />
        <DropDownMenuItem tab={MainScreenTab.OTHERS_BUILDINGS} />
        <DropDownMenuItem tab={MainScreenTab.SEARCH} />

        {/* This view is for expert users only */}
        {isExpertUser && <DropDownMenuItem tab={MainScreenTab.EXPERT_REGISTRATION} />}
        <DropDownMenuItem tab={MainScreenTab.STATISTICS} />
      </DropDownMenu>
    );
  }

  // Tab menu for larger screens
  return (
    <TabMenu mt={2} width={CONTENT_WIDTH.xs} px={CONTENT_PADDING}>
      <TabMenuButton tab={MainScreenTab.BUILDINGS} />
      <TabMenuButton tab={MainScreenTab.OTHERS_BUILDINGS} />
      <TabMenuButton tab={MainScreenTab.SEARCH} />

      {/* This view is for expert users only */}
      {isExpertUser && <TabMenuButton tab={MainScreenTab.EXPERT_REGISTRATION} />}
    </TabMenu>
  );
};
